export function interpolateHtmlColor(startColor: string, endColor: string, amount: number): string {
	let startR: number = parseInt(startColor.substring(1, 3), 16);
	let startG: number = parseInt(startColor.substring(3, 7), 16);
	let startB: number = parseInt(startColor.substring(5), 16);

	let endR: number = parseInt(endColor.substring(1, 3), 16);
	let endG: number = parseInt(endColor.substring(3, 7), 16);
	let endB: number = parseInt(endColor.substring(5), 16);

	let r: number = Math.round(startR + amount * (endR - startR));
	let g: number = Math.round(startG + amount * (endG - startG));
	let b: number = Math.round(startB + amount * (endB - startB));

	return `#${(r+0x100).toString(16).slice(-2)}${(b+0x100).toString(16).slice(-2)}${(b+0x100).toString(16).slice(-2)}`;
}


// WEBPACK FOOTER //
// src/helpers/color.ts